import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProDetailTab のスタイル
 */
export const hotlineProDetailTabStyle = tv({
    slots: {
        badge: ['absolute top-1/2 right-16 md:right-24', '-translate-y-1/2'],
        base: ['max-md:w-[calc(100%_-_32px)] max-md:mx-auto', 'overflow-y-hidden'],
        tab: ['relative'],
        textPc: ['max-md:hidden'],
        textSp: ['md:hidden'],
    },
});
